/* tslint:disable */
/* eslint-disable */
/**
 * Rooming_API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BuildingAlias
 */
export interface BuildingAlias {
    /**
     * 
     * @type {number}
     * @memberof BuildingAlias
     */
    buildingAliasId?: number;
    /**
     * 
     * @type {string}
     * @memberof BuildingAlias
     */
    buildingAliasValue?: string | null;
}

export function BuildingAliasFromJSON(json: any): BuildingAlias {
    return BuildingAliasFromJSONTyped(json, false);
}

export function BuildingAliasFromJSONTyped(json: any, ignoreDiscriminator: boolean): BuildingAlias {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'buildingAliasId': !exists(json, 'buildingAliasId') ? undefined : json['buildingAliasId'],
        'buildingAliasValue': !exists(json, 'buildingAliasValue') ? undefined : json['buildingAliasValue'],
    };
}

export function BuildingAliasToJSON(value?: BuildingAlias | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'buildingAliasId': value.buildingAliasId,
        'buildingAliasValue': value.buildingAliasValue,
    };
}

